import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const CancelSessionModal = ({
  show,
  onClose,
  onConfirm,
  coachName,
  sessionTime,
  isSubmitting = false,
}) => (
  <Modal
    show={show}
    onHide={onClose}
    centered
    className='payment-modal cancel-session-modal'>
    <Modal.Header className='payment-modal-header d-flex justify-content-center border-0'>
      <h3 className='payment-modal-title mb-0'>Cancel Session</h3>
    </Modal.Header>
    <Modal.Body className='payment-modal-body'>
      <div className='s7 text-center'>
        Are you sure you want to cancel your session
        {coachName ? ` with ${coachName}` : ''}?
        {sessionTime && <div className='mt-2 s9 text-muted'>{sessionTime}</div>}
      </div>
    </Modal.Body>
    <Modal.Footer className='border-0 d-flex justify-content-end pt-0'>
      <Button
        variant='secondary-light'
        onClick={onClose}
        className='px-3'
        size='sm'
        disabled={isSubmitting}>
        Keep Session
      </Button>
      <Button
        variant='saffron'
        onClick={onConfirm}
        className='px-3 ms-2 text-white'
        size='sm'
        disabled={isSubmitting}>
        {isSubmitting ? 'Cancelling...' : 'Cancel Session'}
      </Button>
    </Modal.Footer>
  </Modal>
)

export default CancelSessionModal
